// @flow

import type { Settings, SchemaFilterRule } from "@modules/settings/types";
import type { ServiceSettings } from "@modules/service/reducer/service-settings/types";
import type { State } from "@store/reducers";
import { test, filter } from "./utils";
import { cloneObject } from "../../../utils/object";
import type { ClientSettingsSettingsType } from "@modules/settings/types";

export const getSettings = (state: State): Settings | null => {
  return state.settings.settings;
}; //settings.settings ... wtf dude

export const getClientSettings = (state: State): ClientSettingsSettingsType => {
  return (((state.settings || {}).settings || {}).clientSettings || {}).settings;
};

export const getClientSections = (state: State): Object => {
  return (((state.settings || {}).settings || {}).clientSettings || {}).sections;
};

export const getServiceSettings = (state: State): ServiceSettings => {
  return ((state.settings || {}).settings || {}).serviceSettings;
};

export const getFilteredSchema = (state: State, schema: ?Object): ?Object => {
  const schemaRules: ?Array<SchemaFilterRule> =
    schema && state.settings.rules ? state.settings.rules[schema.urn] : null;

  if (!schemaRules) {
    return schema;
  }

  return schemaRules.reduce((acc: Object, rule: SchemaFilterRule) => {
    const _rule = cloneObject(rule);

    // The reason for this crazy code is to add property "value: undefined"
    // because when the static file (modules/settings/rules/employee-absence.js)
    // was added to the redux state in this file(modules/settings/reducer/index.js),
    // the cloneObject method omits properties with "undefined" value.
    // The "test()" method below expect that property and if missing the filtering wouldn't work properly.
    // That is why, the property "value: undefined" need to be added if missing
    _rule.tests = _rule.tests.map(element => {
      if (typeof element.value === "undefined") {
        return {
          ...element,
          value: undefined,
        };
      }

      return element;
    });

    return test(state, _rule.tests) ? filter(acc, _rule.filters) : acc;
  }, schema || {});
};
